<template>
  <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
    <i class="fal fa-spinner fa-spin" /> Loading
  </div>
  <div v-else class="animated fadeIn">
    <basic-heading :title="`Update ${prep_process.name}`" class="mb-3">
      <template #right-content>
        <header-button-group :button_config="button_config" />
      </template>
    </basic-heading>
    <permission-alert-gate :permissions="'edit prep process'">
      <template #gated-content>
        <prep-process-form :prep_process="prep_process" @submit="submit" />
      </template>
    </permission-alert-gate>
  </div>
</template>

<script>
import Vue from "vue";
import VueNotifications from "vue-notifications";
import BasicHeading from "@/components/shared/BasicHeading";
import HeaderButtonGroup from "@/components/shared/headerbuttons/HeaderButtonGroup";
import PermissionAlertGate from "@/components/permission/PermissionAlertGate";
import PrepProcessForm from "@/components/lab/prepprocess/PrepProcessForm";
import { getModel } from "@/shared/fetch-utils";
import { notificationOptions } from "@/shared/toast-notification-options";
import { prepProcessNotifications } from "@/shared/notifications";
import { LabRepositoryFactory } from "@/repositories/lab/LabRepositoryFactory";

const PrepProcessRepository = LabRepositoryFactory.get("prepProcess");

Vue.use(VueNotifications, notificationOptions);

export default {
  name: "PrepProcessEdit",
  components: {
    BasicHeading,
    PermissionAlertGate,
    PrepProcessForm,
    HeaderButtonGroup,
  },
  data() {
    return {
      loading: true,
      laboratory_id: this.$store.getters.getLaboratoryContext.id,
      prep_process_id: this.$route.params.prep_process_id || null,
      prep_process: null,
    };
  },
  computed: {
    button_config() {
      return {
        buttons: [
          {
            icon: "fa-list",
            linkto: "/prep-processes",
            title: "Prep process list",
          },
          {
            icon: "fa-eye",
            linkto: `/prep-processes/${this.prep_process_id}`,
            title: "View prep processes",
            variant: "info",
          },
        ],
      };
    },
  },
  methods: {
    async submit(form_data) {
      try {
        const { data } = await PrepProcessRepository.update(
          this.prep_process_id,
          {
            ...form_data,
            sample_types: form_data.sample_types.map((id) => {
              return {
                id,
              };
            }),
            laboratory_id: this.laboratory_id,
          }
        );

        this.editSuccess();

        this.$router.push(`/prep-processes/${data.prep_process_id}`);
      } catch ({ response }) {
        this.$bvToast.toast(response.data.error, {
          title: "Process update Failed.",
          variant: "danger",
        });
      }
    },
  },
  async created() {
    this.loading = true;

    this.prep_process = await getModel({
      model_type: "prep_process",
      id: this.prep_process_id,
      message: this.$bvToast,
    });

    this.loading = false;
  },
  notifications: prepProcessNotifications,
};
</script>
